module.exports = __webpack_public_path__ + "0f13adf564c7eff7867b64d6c4d829a9.png";